module.exports = __webpack_public_path__ + "static/media/bg3.057f86fd.jpg";